// eslint-disable-next-line no-undef
let prefix = `/`
if (window.CDN_CONFIG.host) {
  prefix = `${window.CDN_CONFIG.host}/`
}
// eslint-disable-next-line no-undef
__webpack_public_path__ = process.env.NODE_ENV === 'production' ? prefix : '/'
